import { type JSX, useState } from "react";
import clsx from "clsx";
import { Button } from "@/shared/ui";
import logo from "@/assets/logo.svg";
import { ConfirmLogoutModal } from "./ConfirmLogoutModal";

export const Header = (): JSX.Element => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      <header
        className={clsx(
          "container-wrapper",
          "bg-brand sticky top-0 right-0 left-0 z-[99] flex w-full items-center justify-between !pt-[23px] !pb-[23px]",
        )}
      >
        <div>
          <img src={logo} alt="" />
        </div>
        <Button
          appearance="secondary"
          size="sm"
          className="!w-fit !border-none !bg-gray-100 !px-3 !py-2 !text-sm !shadow-[0_1px_2px_0_rgba(0,0,0,0.10)]"
          fullWidth
          onClick={() => setIsOpenModal(true)}
        >
          Exit
        </Button>
      </header>
      <ConfirmLogoutModal isOpen={isOpenModal} onClose={() => setIsOpenModal(false)} />
    </>
  );
};
